export const screenHeight = () => {
  return  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

export const screenWidth = () => {
  return  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}